import { render, staticRenderFns } from "./DayNightSwitch.vue?vue&type=template&id=5b57efe8&"
import script from "./DayNightSwitch.vue?vue&type=script&lang=js&"
export * from "./DayNightSwitch.vue?vue&type=script&lang=js&"
import style0 from "./DayNightSwitch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports